interface AutoRefreshNoticeProps {
  errorMessage: string | null
  currentIntervalMs: number
  retryAfterSeconds?: number | null
}

export default function AutoRefreshNotice({
  errorMessage,
  currentIntervalMs,
  retryAfterSeconds,
}: AutoRefreshNoticeProps) {
  if (!errorMessage) {
    return null
  }

  const nextRetrySeconds = retryAfterSeconds ?? Math.max(1, Math.ceil(currentIntervalMs / 1000))

  return (
    <div className="mb-6 rounded-lg border border-amber-300/50 bg-amber-50 px-4 py-3 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100">
      <div className="font-medium">Automatic refresh is backing off</div>
      <div className="mt-1 text-sm">{errorMessage}</div>
      <div className="mt-1 text-xs opacity-80">
        Retrying automatically in about {nextRetrySeconds}s.
      </div>
    </div>
  )
}
